export default __webpack_public_path__ + "static/media/logo-brms.c2a80d24.png";